import { msg, RuleFunction } from 'util/validation'

export const differentThan = <T>(compareValue: T, customMessage?: string): RuleFunction => (inputValue) => {
  if (compareValue === undefined || compareValue === null) {
    return null
  }

  return compareValue === inputValue ? customMessage ?? msg('differentThan', compareValue) : null
}
